import { getColumns, getRows } from "@features/results/Result/NodesTable/helpers"
import { DataGrid } from "@mui/x-data-grid"
import { GraphNodeData } from "@store/services/converter/types"

export type NodesTableRow = {
  numericOrder: number
  id: string
  name: string
  unit: string
}

type NodesTableProps = {
  nodesData: GraphNodeData[]
  onRowDelete: (row: NodesTableRow) => void
}

const NodesTable = (props: NodesTableProps) => {
  const rows = getRows(props.nodesData)
  const columns = getColumns(rows, props.onRowDelete)

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      density="compact"
      disableRowSelectionOnClick
      disableColumnMenu
      disableColumnSelector
      disableColumnFilter
      hideFooter
      getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd")}
      sx={{
        // maxWidth: "850px",
        border: "0px solid black",

        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "rgba(255, 255, 255, 1.0)",
          borderTopRightRadiusRadius: "5px",
          borderTopLeftRadiusRadius: "5px",
        },

        "& .MuiDataGrid-row": {
          "&.even": { backgroundColor: "rgba(255, 255, 255, 1.0)" },
          "&.odd": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
        },

        // remove adding border on cell click
        "& .MuiDataGrid-cell:focus": { outline: " none" },
      }}
    />
  )
}

export default NodesTable
